<div class="w-full bg-white header-section">
  <div
    class="flex max-w-[1600px] mx-auto items-center gap-3 min-h-24 side-padding max-sm:gap-2"
  >
    <img
      alt="menu"
      [src]="urlIcon + 'menu.svg'"
      class="block cursor-pointer lg:hidden"
    />

    <div class="w-80">
      <img
        alt="logo"
        class="cursor-pointer w-144"
        routerLink="/"
        [src]="urlIMG + 'logo-red.png'"
      />
    </div>

    <app-pre-render-sports-menu
      class="self-end justify-between hidden w-full gap-4 pl-4 max-w-814 xl:flex vertical"
    />

    <div
      class="justify-between hidden w-full px-3 py-2 ml-auto border cursor-pointer max-w-329 2xl:flex text-14 font-Roboto-400 border-grey-8 rounded-100"
    >
      <div class="text-nowrap">Buscar Partidos, Jugadores, Ligas</div>
      <img alt="search" [src]="urlIcon + 'search-grey.svg'" />
    </div>

    <div
      class="flex w-fit items-center gap-3 max-sm:gap-2 max-[400px]:min-w-14 min-w-[65px] max-2xl:min-w-[96px] ml-auto max-[410px]:flex-col max-[410px]:items-center"
    >
      <div class="flex gap-3 max-sm:gap-2">
        <img
          alt="search"
          [src]="urlIcon + 'search-grey-1.svg'"
          class="block 2xl:hidden cursor-pointer max-sm:w-[17px]"
        />

        <img
          alt="calendar"
          [src]="urlIcon + 'calendar-grey.svg'"
          class="block lg:hidden cursor-pointer max-sm:w-[17px]"
          nz-popover
          nzPopoverPlacement="bottom"
        />

        <!-- <img
          alt="news"
          [routerLink]="['/noticias']"
          class="w-[20px] max-sm:w-[17px] cursor-pointer 2xl:hidden block"
          [src]="urlIcon + 'news.png'"
        /> -->

        <!-- <ng-template #calendarModal>
          <app-calender
            class="lg:hidden absolute left-1/2 -translate-x-1/2"
            [isfloating]="true"
            [selectedDateInput]="selectedCalendarDate()"
            (onDateSelected)="changeDataCalendar($event)"
            (onClose)="closeCalendar()"
          ></app-calender>
        </ng-template> -->
      </div>

      <div class="flex gap-3 max-sm:gap-2">
        <img
          alt="favorite"
          [src]="urlIcon + 'fav-outlined.svg'"
          class="cursor-pointer max-sm:w-[17px]"
          routerLinkActive="router-link-active"
        />

        <img
          alt="mode"
          [src]="urlIcon + 'moon.svg'"
          class="cursor-pointer max-sm:w-[15px]"
        />
      </div>
    </div>

    <img
      alt="spain-flag"
      [src]="urlIMG + 'spain-flag.png'"
      class="cursor-pointer rounded-full max-w-24 h-24 max-sm:w-[20px] max-sm:h-[20px]"
    />

    <img
      alt="uk-flag"
      [src]="urlIMG + 'uk-flag.png'"
      class="cursor-pointer rounded-full max-w-24 h-24 max-sm:w-[20px] max-sm:h-[20px]"
    />

    <div class="flex items-center gap-3 max-sm:gap-1 max-sm:flex-col">
      <button class="text-red-2 font-roboto-700 max-sm:text-12 text-nowrap">
        Inicia sesión
      </button>

      <button class="text-red-2 font-roboto-700 text-nowrap max-sm:text-12">
        Regístrate
      </button>
    </div>
  </div>

  <app-pre-render-sports-menu
    class="flex self-end justify-between w-full gap-4 overflow-x-auto xl:hidden hidden-scrollbar side-padding max-sm:px-1"
  />

  <app-pre-render-left-menu
    *ngIf="globalState.handleMenu()"
    class="absolute max-w-319 w-full left-3 top-[150px] z-10 block lg:hidden border-grey-5 shadow-lg border rounded-10"
    [isfloating]="true"
  />
</div>
